import API from "@/api"

const resource = "/participants"

export default {
    getIncidents(participantEmail, project_id, daysBack) {
        return API.get(`${resource}/${participantEmail}/incidents/${daysBack}?project_id=${project_id}`)
    }
}
